import { createContext } from 'react';
export const CreditsContext = /*#__PURE__*/createContext(undefined);